export const requestIdleCallbackWithFallback = callback => {

	if ('requestIdleCallback' in window) {
		window.requestIdleCallback(callback);
	} else {
		window.setTimeout(callback, 0);
	}

};



// WEBPACK FOOTER //
// ./utils/request-idle-callback.js